import { createEvent, sample } from 'effector';
import { gameFieldModel } from 'widgets/game-field';
import { gameModel } from 'entities/game';
import { createGetResultQuery } from 'shared/api';
import { resultRoute } from 'shared/routes';

const getResultQuery = createGetResultQuery();

const $result = getResultQuery.$data;

const setup = createEvent();

sample({
	clock: $result,
	filter: resultRoute.$isOpened,
	fn: (result) => result?.mults || [],
	target: gameModel.$multipliers,
});

sample({
	clock: $result,
	source: gameFieldModel.$cells,
	filter: resultRoute.$isOpened,
	fn: (cells, result) =>
		cells.map((row, ri) =>
			row.map((_, ci) => {
				if (result?.turnHistory[ri] === ci) {
					if (result?.mines[ri].includes(ci)) return 'mistake';

					return 'ball';
				}
				if (!result?.mines[ri].includes(ci)) return 'ghost';

				return 'default';
			}),
		),
	target: gameFieldModel.$cells,
});

sample({
	clock: setup,
	source: resultRoute.$query,
	filter: resultRoute.$isOpened,
	fn: (query) => query.token,
	target: getResultQuery.start,
});

export const resultModel = {
	$result,
	setup,
};
